import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import "HELPDESK/CommonResources/ViewAttachment/viewAttachment.css";

export class ViewAttachment extends Component {
    constructor(props) {
        super(props);
        this.state = {
  
        };
    }
    
    render() {
        

        let imageExtensions = ['png', 'jpg', 'jpeg', 'svg'];
        return (
            <div className={this.props.viewAttachment ? "modal fade show" : "modal fade"} id="modalContainer">

                <div className="modal-dialog modal-dialog-centered modal-xl viewAttachmentDialog">
                    <div className="modal-content viewAttachmentContent">
                        <div className="modal-header">
                            <div className="icon-container">
                                <FontAwesomeIcon icon={['fas', 'paperclip']} size="lg" color='#0465AC' style={{ fontSize: 20 }} />
                            </div>
                            <h3 style={{ textTransform: "capitalize", fontSize: 20 }}>Attachment</h3>
                            <FontAwesomeIcon
                                icon={['fas', 'times']}
                                style={{ cursor: 'pointer' }}
                                size="lg"
                                color="#000000"
                                onClick={() => this.props.closeAttachment()} // Close the modal
                            />
                        </div>
                        <div className="modal-body viewAttachment-body">
                            {
                                imageExtensions.includes(this.props.attachmentFileExtension) ?
                                    <div>
                                        <img src={this.props.attachmentPath + '/' + this.props.attachmentFile} alt='attachmentimg' width='100%' height='100%' />
                                    </div>
                                    :
                                    <iframe title='attachmentPath' src={this.props.attachmentPath + '/' + this.props.attachmentFile} alt="attachment" width='100%' height='100%' />
                            }
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

export default ViewAttachment
